import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 26133 5276"
    {...props}
  >
    <rect
      width={25029}
      height={4171}
      x={552}
      y={552}
      rx={7822}
      ry={4171}
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 1104.2,
      }}
      className="stroke1 fill"
    />
  </svg>
)
export default SvgComponent
